import Sign from "@/modules/authentication/Sign";
const config = {
    roles: {
        opublic: ['public'],
        public: ['public', 'guest', 'administrator'],
        guest: ['guest', 'administrator'],
        administrator: ['administrator']
    }
}


export default {
    signin: {
        path: "/signin",
        name: "Signin",
        component: Sign,
        meta: { roles: config.roles.opublic },
    },
    signup: {
        path: "/signup",
        name: "Signup",
        component: Sign,
        meta: { roles: config.roles.opublic },
    },
    resetpassword: {
        path: "/resetpassword/:token",
        name: "ResetPassword",
        component: Sign,
        meta: { roles: config.roles.opublic },
    },
    forgotpassword: {
        path: "/forgotpassword",
        name: "ForgotPassword",
        component: Sign,
        meta: { roles: config.roles.opublic },
    },
    confirmation: {
        path: "/confirmation/:token",
        name: "ConfirmationEmail",
        component: Sign,
        meta: { roles: config.roles.public },
    }
};